import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestLogout } from "./logout.request";

const useLogout = (
  options?: MutationOptions<unknown, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestLogout,
    ...options
  });
};

export default useLogout;
